<template>
  <div>
    <el-dialog
      id="openMethodSel"
      class="KNS-dialog"
      :visible.sync="openMethodSel"
      width="900px"
      center
    >
      <span
        slot="title"
        class="dialog-title"
      >
        <div class="title-bar">
          <span class="title">快速開通服務</span>
          <span class="subtitle">請選擇開通方式－戶別：{{ tabletInfo.tablet_note }}</span>
        </div>
        <div
          class="advanced-cog"
          @click="$toPage('comOpenServiceStatus')"
        >
          <i
            class="icon-cog"
            aria-hidden="true"
          />
          進階功能 (開通狀況、解除綁定)
        </div>
      </span>
      <div class="way-select">
        <h5>請選擇您的開通方式</h5>
        <ul>
          <li @click="barcodeOpen">
            <img
              src="../assets/img/Barcode/barcode.png"
              alt="新增裝置"
            >
            <h3>手機條碼</h3>
          </li>
          <li @click="nfcOpen">
            <img
              src="../assets/img/NFC/nfc.png"
              alt="新增載具"
            >
            <h3>門禁卡、磁扣</h3>
          </li>
          <li @click="snOpen">
            <img
              src="../assets/img/SN/sn.png"
              alt="新增裝置"
            >
            <h3>手機序號</h3>
          </li>
        </ul>
      </div>
    </el-dialog>
    <reader ref="reader" />
    <hosuehold-frame
      :open.sync="householdSwitch"
      type="KNS-HK"
      :title="titleObj"
      @select-household="selectedHousehold"
    />

    <el-dialog
      id="SNGetDialog"
      class="KNS-dialog"
      :visible.sync="SNGetDialog"
      width="50vw"
      center
      @closed="SN=''"
    >
      <span
        slot="title"
        class="dialog-title"
      >
        <div class="title-bar">
          <span class="title">戶別：{{ tabletInfo.tablet_note }}</span>
        </div>
      </span>
      <div class="SNOpen-wrap">
        <div class="SN-wrap">
          <div class="title">
            開通序號
          </div>
          <div class="SN">
            {{ SN }}
          </div>
          <div class="button">
            <el-button
              type="primary"
              :disabled="SNGeting"
              @click="btnGetSN"
            >
              產生序號
            </el-button>
          </div>
        </div>
        <div class="info-wrap">
          <p>以上產出每組序號，請<span class="tag">住戶輸入</span>，並於<span class="tag">24小時內 手機進行開通</span>，</p>
          <p>每組序號限一支手機開通使用，若未於時間內開通則本組序號將為失效。</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import householdFrame from '@/components/HouseholdFrame'
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
export default {
  components: {
    'hosuehold-frame': householdFrame,
    reader: ReadNFCBarcode
  },
  data () {
    return {
      openMethodSel: false,
      householdSwitch: false,
      SNGetDialog: false,
      tabletInfo: Object,
      titleObj: {
        title: '快速開通服務',
        SubTitle: '請選擇住戶資訊(棟別、樓層、戶別)',
        introduction: 'https://www.smartdaily.com.tw/guide-to-use-certified-the-residents/',
        btn: {
          icon: 'icon-cog',
          text: '進階功能 (開通狀況、解除綁定)',
          btnevent () {
            window.location.href = `${window.location.origin}/community/comOpenServiceStatus.aspx`
          }
        }
      },
      SN: '',
      SNGeting: false
    }
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    faseActive () {
      this.householdSwitch = true
    },
    selectedHousehold (val) {
      this.tabletInfo = val
      this.householdSwitch = false
      this.openMethodSel = true
    },
    nfcOpen () {
      const vobj = this
      this.$refs.reader.getCode((code) => {
        sandAPI(code)
        function sandAPI (code) {
          const codeList = []
          let nowInd = 0
          if (typeof (code) === 'string') { codeList.push(code) } else { code.map(val => codeList.push(val)) }
          API()
          function API () {
            console.log(`ind:${nowInd}`)
            vobj.nfcOpenApi(codeList[nowInd]).then(res => {
              let msgObj = Object
              // eslint-disable-next-line eqeqeq
              if (res.data.status == 'fail' || res.data.status == 'error') {
                msgObj = { title: '新增失敗!!', message: '請洽今網技術支援中心。', type: 'error' }
              } else {
                // eslint-disable-next-line eqeqeq
                if (res.data.status == 'repeat') {
                  msgObj = { title: '載具已歸戶!!', message: '', type: 'success' }
                // eslint-disable-next-line eqeqeq
                } else if (res.data.status == 'restart') {
                  msgObj = { title: '載具已重新啟用!!', message: '住戶可憑此載具進行包裹領取', type: 'success' }
                } else {
                  msgObj = { title: '載具新增成功!!', message: '住戶可憑此載具進行包裹領取', type: 'success' }
                }
              }
              if (codeList.length > 1) { msgObj.title = `(${nowInd + 1}/${codeList.length})` + msgObj.title }
              vobj.$notify(msgObj)
              nowInd++
              if (nowInd <= codeList.length - 1) {
                API()
              } else {
                vobj.$refs.reader.close()
              }
            }).catch(err => {
              vobj.$notify.error({ title: '發生未知錯誤!!', message: '請洽今網技術支援中心。' })
              if (nowInd <= codeList.length - 1) {
                API()
              } else {
                vobj.$refs.reader.close()
              }
            })
          }
        }
      }, {
        type: 'NFC',
        model: 'active',
        tabletInfo: this.tabletInfo
      })
    },
    barcodeOpen () {
      const vobj = this
      this.$refs.reader.getCode((code) => {
        sandAPI(code)
        function sandAPI (code) {
          const codeList = []
          let nowInd = 0
          if (typeof (code) === 'string') { codeList.push(code) } else { code.map(val => codeList.push(val)) }
          API()
          function API () {
            console.log(`ind:${nowInd}`)
            vobj.BarcodeOpenApi(codeList[nowInd]).then(res => {
              let msgObj = Object
              // eslint-disable-next-line eqeqeq
              if (res.data.status == 'success' || res.data.status == 'update_success') {
                msgObj = { title: '裝置開通成功!!', message: '住戶可憑此手機條碼進行包裹領取', type: 'success' }
              } else {
                // eslint-disable-next-line eqeqeq
                if (res.data.status == 'com_tablet_device_repeat') {
                  msgObj = { title: '裝置已開通!!', message: '', type: 'success' }
                } else {
                  msgObj = { title: '開通失敗!!', message: '請洽今網技術支援中心。', type: 'error' }
                }
              }
              if (codeList.length > 1) { msgObj.title = `(${nowInd + 1}/${codeList.length})` + msgObj.title }
              vobj.$notify(msgObj)
              nowInd++
              if (nowInd <= codeList.length - 1) {
                API()
              } else {
                vobj.$refs.reader.close()
              }
            }).catch(err => {
              vobj.$notify.error({ title: '發生未知錯誤!!', message: '請洽今網技術支援中心。' })
              if (nowInd <= codeList.length - 1) {
                API()
              } else {
                vobj.$refs.reader.close()
              }
            })
          }
        }
      }, {
        type: 'Barcode',
        model: 'active',
        tabletInfo: this.tabletInfo
      })
    },
    snOpen () {
      this.SNGetDialog = true
    },
    nfcOpenApi (code) {
      return new Promise((resolve, reject) => {
        const url = process.env.NODE_ENV === 'development' ? '/house/validCarrierCode' : `${process.env.VUE_APP_WS_URL}/validCarrierCode`
        const formdata = new FormData()
        formdata.append('t', this.tabletInfo.tablet_id)
        formdata.append('code', code)
        formdata.append('type', true)
        axios(url, {
          method: 'POST',
          data: formdata,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    BarcodeOpenApi (code) {
      return new Promise((resolve, reject) => {
        const url = process.env.NODE_ENV === 'development' ? '/house/validMoibleCode' : `${process.env.VUE_APP_WS_URL}/validMoibleCode`
        const formdata = new FormData()
        formdata.append('t', this.tabletInfo.tablet_id)
        formdata.append('code', code)
        formdata.append('type', true)
        axios(url, {
          method: 'POST',
          data: formdata,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    snOpenApi () {
      return new Promise((resolve, reject) => {
        const url = process.env.NODE_ENV === 'development' ? '/house/getSerialService' : `${process.env.VUE_APP_WS_URL}/getSerialService`
        const formdata = new FormData()
        formdata.append('t', this.tabletInfo.tablet_id)
        axios(url, {
          method: 'POST',
          data: formdata,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    btnGetSN () {
      this.SNGeting = true
      this.snOpenApi().then((res) => {
        this.SN = res.data.serial
        this.SNGeting = false
      }).catch(() => {
        this.SNGeting = false
        this.$notify({ title: '發生未知錯誤!!', message: '請洽今網技術支援中心。', type: 'error' })
      })
    }
  }
}
</script>

<style lang="sass" scoped>
  .KNS-dialog
    ::v-deep .el-dialog
      +KNSDialog
      .el-dialog__body
        padding: 20px 15px 20px 15px
  .way-select
    h5
      font-size: 28px
      text-align: center
      color: #f45f53
      margin: 10px 0px
      font-weight: 500
    img
      width: 160px
      height: 160px
      object-fit: contain
      margin-top: 20px
    ul
      padding: 0 !important
  #SNGetDialog
    +SNGetDialog
</style>
